import { Injectable } from '@angular/core';
import { getConnection, getCurrentUser, getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from 'src/app/core/services/requests.service';

@Injectable({
  providedIn: 'root',
})
export class EtiquetasGestionService {

  endpointInsert: string = ""
  endpointUpdate: string = ""

  constructor(private requestsService: RequestsService) {
    // --> capturamos los endpoints
    this.setEndpoints()
  }

  transformEtiquetasToInsert(etiquetas: EtiquetaNog[]) {
    return etiquetas ? etiquetas.map((value, index) => {
      value["c_emp"] = getConnection();
      value["cod_eti"] = 1;
      return value;
    }) : []
  }

  setEndpoints() {
    this.endpointInsert = getEndpoint("EtiquetasDeGestionCartera_insert")
    this.endpointUpdate = getEndpoint("EtiquetasDeGestionCartera_update")
  }

  async activarEtiquetasNog(etiquetas: EtiquetaNog[]) {
    let result = await this.requestsService.postLikeJSON(this.endpointInsert, {
      company: getConnection(),
      api_key: "d47c29cfdf8e2456ac678c51f9e4ddfa8ec577f64e98aa9e863399f6a10210d4",
      usuario: getCurrentUser().usuario_aplicativo,
      data: this.transformEtiquetasToInsert(etiquetas),
    })
    return result
  }

  async desactivarEtiquetasNog(etiquetas: EtiquetaNog[]) {
    let result = await this.requestsService.postLikeJSON(this.endpointUpdate, {
      company: getConnection(),
      api_key: "d47c29cfdf8e2456ac678c51f9e4ddfa8ec577f64e98aa9e863399f6a10210d4",
      usuario: getCurrentUser().usuario_aplicativo,
      data: this.transformEtiquetasToInsert(etiquetas)
    })

    return result
  }
}

export class EtiquetaNog {
  c_emp: string
  c_agr: string
  t_cre: string
  cue: string
  n_ide: string
  origen: string
  cod_eti?= 1
}
